export default __webpack_public_path__ + "ee119d419effc793e5ac50ee6e2d70dc.svg";